// Menu Drawer
const menuDrawerControl = document.getElementById('menu-drawer-control');
if (menuDrawerControl) {
    const menuDrawer = document.getElementById('menu-drawer');
    const menuDrawerCloseControl = document.getElementById('menu-drawer-close-btn');
    const menuDrawerOverlay = document.querySelector('#menu-drawer-overlay');

    const openMenuDrawer = () => {
        setTimeout(() => {
            menuDrawer.classList.add('open')
            menuDrawerOverlay.classList.add('open')
        }, 50);
    };

    const closeMenuDrawer = () => {
        menuDrawer.classList.remove('open');
        menuDrawerOverlay.classList.remove('open');
    };

    menuDrawerControl.addEventListener('click', openMenuDrawer);
    menuDrawerCloseControl.addEventListener('click', closeMenuDrawer);

    menuDrawerOverlay.addEventListener('click', (event) => {
        if (!menuDrawer.contains(event.target)) {
            closeMenuDrawer();
        }
    });
}

// Hero balloons ease away from the pointer
const heroSky = document.querySelector('.home.top-section');
if (heroSky) {
    import('@/scripts/balloon-nudge.js').then(({default: initBalloonNudge}) => initBalloonNudge(heroSky));
}

// Pointer trail on the Hire Students logos: the hero one where a page has it,
// and the header one, which is on every page. The header host is the existing
// .logo wrapper, so no header partial needed changing.
const rippleHosts = [
    document.getElementById('hero-logo'),
    document.querySelector('header .logo'),
].filter(Boolean);

if (rippleHosts.length) {
    import('@/scripts/logo-ripple.js').then(({default: initLogoRipple}) => {
        rippleHosts.forEach((host) => initLogoRipple(host));
    });
}

// Buttons that dim on hover keep their original colour under the cursor.
import('@/scripts/button-ripple.js').then(({default: initButtonRipple}) => initButtonRipple());

// The How it works page arrives a section at a time as the reader scrolls.
const hiwDemos = Array.from(document.querySelectorAll('[data-hiw-demo]'));
const hiwRisers = Array.from(document.querySelectorAll('.hiw-rise'));
if (hiwDemos.length || hiwRisers.length) {
    import('@/scripts/hiw-reveal.js').then(({default: initHowItWorksDemos}) => initHowItWorksDemos(hiwDemos, hiwRisers));
}

window.handleCardClick = (event, targetUrl) => {
    if (event.target.classList.contains('btn-favourite') || event.target.closest('.btn-favourite')) {
        return;
    }

    if (event.target.tagName === 'A' || event.target.closest('a')) {
        return;
    }

    window.location.href = targetUrl;
}
